import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../utils/cn";
import { fieldClass } from "./fieldClass";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/**
 * Text/number input. A thin, controlled wrapper over the native <input> that
 * carries the kit's field styling (matches the Select trigger). All native
 * props (value, onChange, type, placeholder, disabled…) pass straight through.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(fieldClass, "flex py-2", className)}
      {...props}
    />
  ),
);
Input.displayName = "Input";
